
export default class HeadingObj{
    public colNo:Number;    
    public Meetings:number;
    public SSO:number;
    public PlannerTask:number;
    public Events:number;
    public TODOS:number;
    public FlaggedEmail:number;
    public RecentFiels:number;
    public Total:number;
    public MSList:number;
    public title:string;
    public currentselection:any[];
    public constructor (Title:string,CalNo:number,options){
        this.colNo=CalNo;
        this.Meetings=0;
        this.SSO=0;
        this.PlannerTask=0;
        this.Events=0;
        this.TODOS=0;
        this.Total=0;
        this.MSList=0;
        this.RecentFiels=0;
        this.title=Title;
        this.currentselection=options;
    }
}
